import React, {useState, useEffect, useCallback} from 'react';
import '../commentaires.css';

export const Commentaires = (props) => {
  const [commentaires, setCommentaires] = useState([]);
  const fetchDataCommentaire = useCallback(async () => {
    try {
      const response = await fetch(`https://applications.alphitan-system.tech/Commentaire.php?id=${props.id}`);
      const data = await response.json();
      setCommentaires(data);
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  }, [props.id]);
  useEffect(() => {
    fetchDataCommentaire();
  }, [fetchDataCommentaire]);
  return (
    <div>
      {commentaires.length > 0 ? (
        commentaires.map((commentaire, index) => (
          <div className="row text-left mt-5 border border-black col-md-4" style={{margin: "10px"}} key={index}>
            <span style={{fontFamily: "italic", fontSize: "1.4vh"}} className="ms-2">{commentaire.date_ajout}</span>
            <span style={{fontFamily: "italic"}} className="ms-2 bold">{commentaire.nom} a dit : </span>
            <span style={{fontFamily: "italic"}} className="ms-2">{commentaire.commentaire}</span>
          </div>
        ))
      ) : (
        <div className="loading px-2">Aucun commentaire à afficher</div>
      )}
    </div>
  )
};
